import { User } from "@/actions/wp";
import links from "@/constants/links";
import { CloseIconSmall } from "@/assets/images/svg/Icons";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

type Props = {
  isBasicPlan?: boolean;
  userInfo: User;
  onClose: () => void;
};

const DashboardInfoBaner = ({ isBasicPlan, userInfo, onClose }: Props) => {
  return (
    <>
      {!isBasicPlan && (
        <div className="account__header">
          <div className="info-baner">
            <div className="info-baner__wrapper">
              <div className="">
                <h5 className="info-baner__wrapper--title">
                  Cześć {userInfo?.first_name},
                </h5>

                <p className="info-baner__wrapper--description">
                  Cieszę się, że wybrałeś moją platformę "Health and Body
                  Academy". <br></br>
                  <Link to={links.panelMessages}>
                    Przejdź teraz do zakładki wiadomości
                  </Link>{" "}
                  - czeka tam na Ciebie wprowadzenie do korzystania z platformy
                  oraz pierwsze zadanie!
                </p>
              </div>

              <div className="info-baner__wrapper__close">
                <Button variant="link" onClick={onClose}>
                  Przeczytałem, nie pokazuj więcej <CloseIconSmall />
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isBasicPlan && (
        <div className="account__header">
          <div className="info-baner">
            <div className="info-baner__wrapper">
              <div className="">
                <h5 className="info-baner__wrapper--title">
                  Cześć {userInfo?.first_name},
                </h5>

                <p className="info-baner__wrapper--description">
                  Cieszę się, że wybrałeś plan Adaptacja i dołączyłeś do{" "}
                  <span style={{ fontStyle: "italic" }}>
                    Health and Body Academy
                  </span>
                  . To świetny sposób, by zacząć swoją przygodę z treningiem i
                  zdrowym stylem życia - krok po kroku, w swoim tempie.
                  <br></br>
                  <br></br>W zakładce{" "}
                  <Link to={links.panelVideo}>Ćwiczenia wideo</Link> znajdziesz
                  dostęp do krótkich, autorskich klipów instruktażowych. Dzięki
                  nim z łatwością nauczysz się prawidłowej techniki każdego
                  ćwiczenia z planu.
                  <br></br>
                  <br></br>W zakładce{" "}
                  <Link to={links.panelDiet}>Kreator diet</Link> możesz stworzyć
                  pełnowartościowy posiłek w prosty i intuicyjny sposób.
                  Wybierz, czy wolisz jeść trzy, cztery czy pięć posiłków
                  dziennie - i stwórz plan, który pasuje do Ciebie.
                  <br></br>
                  <br></br>W zakładce{" "}
                  <Link to={links.panelTraining}>Trening</Link> dostępny jest
                  uniwersalny plan treningowy na cały miesiąc, stworzony z myślą
                  o stopniowym budowaniu formy.
                  <br></br>
                  <br></br>
                  Masz już wszystko, czego potrzebujesz, by zacząć działać.
                  Przejdź do odpowiednich zakładek i rozpocznij swój plan z
                  energią i motywacją!
                </p>
              </div>

              <div className="info-baner__wrapper__close">
                <Button variant="link" onClick={onClose}>
                  Przeczytałem, nie pokazuj więcej <CloseIconSmall />
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DashboardInfoBaner;
